export default "__VITE_ASSET__Dcgip8YT__"